import React from "react";
import { Helmet } from "react-helmet";

const DynamicTitle = ({title = "Fitrizer"}) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default DynamicTitle;